"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _StripesTheme = require("../..//StripesTheme.js");

var _react2 = require("../..");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    position: absolute;\n    top: ", ";\n    left: 50%;\n    margin: 0 auto;\n    transform: translate(-50%, ", ");\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: rgba(100,100,100,0.425);\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    opacity: ", ";\n    visibility: ", ";\n    transition: opacity 0.25s linear;\n    transition-delay: 0s;\n    z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DialogWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.open ? 1 : 0;
}, function (props) {
  return props.open ? 'visible' : 'hidden';
}, function (props) {
  return props.spacingObj.menuZIndex;
});

var DialogBodyWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.width;
}, function (props) {
  return props.top;
}, function (props) {
  return props.open ? '-' + (props.anchorTo ? 0 : props.top) : '-80%';
});

var HeaderWrapper = _styledComponents["default"].div(_templateObject3());
/**
 * Dialogs inform users about a task and can contian critical information, require decisions, or involve multiple tasks.
 * This Dialog uses a nested Card component so it makes use of all the same props.
 * Available functions via refs:
 * - toggleDialog()
 * - open()
 * - close()
 * @example import { Dialog } from '@badger/react';
 */


var Dialog = (0, _react.forwardRef)(function (props, ref) {
  var inherit = "dialog";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openState = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)('50%'),
      _useState4 = _slicedToArray(_useState3, 2),
      top = _useState4[0],
      setTop = _useState4[1];

  (0, _react.useEffect)(function () {
    setTop(props.anchorTo ? getElementTop(props.anchorTo) : '50%');
  }, []);

  function getElementTop(element) {
    if (typeof element === 'string') {
      return element;
    }

    var elRect = _reactDom["default"].findDOMNode(element).getBoundingClientRect();

    return elRect.top + elRect.height + 'px';
  }

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      toggleDialog: toggleDialog,
      open: open,
      close: close
    };
  });

  function toggleDialog(value) {
    setOpen(value !== undefined ? value : !openState);

    if (!value) {
      props.onClose();
    }
  }

  function open() {
    toggleDialog(true);
  }

  function close() {
    toggleDialog(false);
  }

  var titleNode = /*#__PURE__*/_react["default"].createElement(HeaderWrapper, null, props.title, props.showClose && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      cursor: 'pointer',
      marginLeft: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'close',
    category: 'navigation',
    color: colors.iconColor,
    size: 30,
    onClick: function onClick() {
      return setOpen(false);
    }
  })));

  return /*#__PURE__*/_react["default"].createElement(DialogWrapper, {
    className: "Dialog " + props.className,
    open: openState,
    width: props.width,
    style: props.style,
    spacingObj: spacing
  }, /*#__PURE__*/_react["default"].createElement(DialogBodyWrapper, {
    open: openState,
    anchorTo: props.anchorTo,
    top: top,
    width: props.width
  }, /*#__PURE__*/_react["default"].createElement(_react2.Card, {
    title: titleNode,
    items: props.items,
    type: "primary",
    style: props.cardStyle,
    headerStyle: props.headerStyle,
    subtitleStyle: props.subtitleStyle,
    overlineStyle: props.overlineStyle,
    footerStyle: props.footerStyle,
    bodyStyle: props.bodyStyle,
    actions: props.actions
  }, props.children)));
});
exports.Dialog = Dialog;
Dialog.propTypes = {
  /**The content displayed in the body of the dialog . */
  children: _propTypes["default"].node,

  /**REVISIT THIS */
  items: _propTypes["default"].array,

  /**REVISIT THIS */
  itemOrder: _propTypes["default"].string,

  /**Defines the styling of the dialog. */
  type: _propTypes["default"].string,

  /**Content to display in the header of the dialog element . */
  title: _propTypes["default"].string,

  /**Content to display in the header of the dialog element below the title . */
  subtitle: _propTypes["default"].string,

  /**Content to display in the header of the dialog element above the title . */
  overline: _propTypes["default"].string,

  /**Extends the base styling of the dialog element. */
  style: _propTypes["default"].object,

  /**Extends the base styling of the dialog header. */
  headerStyle: _propTypes["default"].object,

  /**Extends the base styling of the dialog subtitle. */
  subtitleStyle: _propTypes["default"].object,

  /**Extends the base styling of the dialog overline. */
  overlineStyle: _propTypes["default"].object,

  /**Extends the base styling of the dialog footer. */
  footerStyle: _propTypes["default"].object,

  /**Show or hide the close icon in the dialog. */
  showClose: _propTypes["default"].bool,

  /**The percentage of the page-width the dialog takes up. */
  width: _propTypes["default"].string,

  /**Pass through a react component reference, or a css top position value (this.ref.NavBar or "0px"). */
  anchorTo: _propTypes["default"].object,

  /**A callback function that is fired when the dialog is closed. */
  onClose: _propTypes["default"].func
};
Dialog.defaultProps = {
  style: {},
  cardStyle: {},
  headerStyle: {},
  subtitleStyle: {},
  overlineStyle: {},
  footerStyle: {},
  bodyStyle: {},
  showClose: true,
  title: null,
  items: [],
  width: '33%',
  className: "",
  anchorTo: null,
  onClose: function onClose() {
    return false;
  },
  actions: null
};